(function () {
  "use strict";

  var HEAD_RE = /one shape doesn.?t fit every mouth/i;
  var TAIL_RE = /no restocking fee/i;
  var CLOSE_SEL = 'button, [class*="close"], [id*="close"], [data-dismiss], [aria-label*="close" i], svg, img';
  var QUIZ_URL = "/pages/fit-quiz";
  var MEN_ID = "40088126849093";
  var WOMEN_ID = "40088126881861";
  var POP_SEL = '[role="dialog"], [aria-modal="true"], .modal, .popup, [class*="popup"], [class*="modal"]';
  var CART_SEL = '#slidecarthq, [id*="slidecart" i], [class*="slidecart" i], [class*="slide-cart" i]';
  var TRIGGER_RE = /^size guide$/i;

  var SIZES = [
    { key: "men", id: MEN_ID, label: "Men's", re: /^men.?s(\s+size)?$/i },
    { key: "women", id: WOMEN_ID, label: "Women's", re: /^women.?s(\s+size)?(\s*.\s*10%\s*smaller)?$/i }
  ];

  function txt(el) {
    return (el.textContent || "").replace(/\s+/g, " ").trim();
  }

  function byText(root, re, tags, maxLen) {
    var nodes = root.querySelectorAll(tags);
    var best = null;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = txt(el);
      if (!t || t.length > maxLen) continue;
      if (!re.test(t)) continue;
      if (!best || best.contains(el)) best = el;
    }
    return best;
  }

  function promote(el) {
    var t = txt(el);
    var n = el;
    while (n.parentElement && n.parentElement !== document.body && txt(n.parentElement) === t) {
      n = n.parentElement;
    }
    return n;
  }

  function isProtected(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches(CLOSE_SEL)) return true;
    if (node.querySelector && node.querySelector(CLOSE_SEL)) return true;
    return false;
  }

  function dialogOf(el) {
    var n = el;
    for (var i = 0; i < 8 && n; i++) {
      if (n.matches && n.matches(POP_SEL)) return n;
      n = n.parentElement;
    }
    return null;
  }

  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function isCartUi(el) {
    return !!(el && ((el.matches && el.matches(CART_SEL)) || (el.closest && el.closest(CART_SEL))));
  }

  function outermost(dlg) {
    var n = dlg;
    while (
      n.parentElement &&
      n.parentElement !== document.body &&
      n.parentElement.matches &&
      n.parentElement.matches(POP_SEL)
    ) {
      n = n.parentElement;
    }
    return n;
  }

  function hardHide(el) {
    if (!el || isCartUi(el)) return;
    el.setAttribute("data-vs-forced", "1");
    if (el.tagName === "DIALOG" && typeof el.close === "function") {
      try {
        el.close();
      } catch (err) {}
    }
    el.removeAttribute("open");
    el.style.setProperty("display", "none", "important");
  }

  function hideBackdrops(root) {
    var cands = document.querySelectorAll('[class*="backdrop" i], [class*="scrim" i], [class*="overlay" i]');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (isCartUi(el)) continue;
      if (el === root || el.contains(root)) continue;
      if (!visible(el)) continue;
      if (txt(el)) continue;
      if (el.querySelector("button, a, input")) continue;
      var pos = window.getComputedStyle(el).position;
      if (pos !== "fixed" && pos !== "absolute") continue;
      hardHide(el);
    }
  }

  function unlockScroll() {
    if (document.querySelector(CART_SEL) && visible(document.querySelector(CART_SEL))) return;
    var els = [document.body, document.documentElement];
    for (var i = 0; i < els.length; i++) {
      if (els[i] && els[i].style && els[i].style.overflow === "hidden") els[i].style.overflow = "";
    }
  }

  function closeDialog(dlg, done) {
    done = done || function () {};
    if (!dlg) {
      done();
      return;
    }

    if (dlg.tagName === "DIALOG" && typeof dlg.close === "function") {
      try {
        dlg.close();
      } catch (err) {}
    }

    var btn = dlg.querySelector('[class*="close"], [id*="close"], [aria-label*="close" i], [data-dismiss]');
    if (btn && typeof btn.click === "function") btn.click();

    if (dlg.id && location.hash === "#" + dlg.id) location.hash = "vs-sg-off";

    setTimeout(function () {
      var root = outermost(dlg);
      if (visible(root)) {
        hardHide(root);
        hideBackdrops(root);
      }
      unlockScroll();
      done();
    }, 220);
  }

  function inCart(size) {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) return false;
        return r.json();
      })
      .then(function (c) {
        if (!c || !c.items) return false;
        for (var i = 0; i < c.items.length; i++) {
          if (String(c.items[i].id) === String(size.id)) return true;
        }
        return false;
      })
      .catch(function () {
        return false;
      });
  }

  function addToCart(size) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(size.id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed " + r.status);
      return r.json().catch(function () {
        return null;
      });
    });
  }

  function openCart() {
    var opened = false;
    var tries = 0;

    function doOpen() {
      if (opened) return;
      opened = true;
      if (typeof window.SLIDECART_OPEN === "function") window.SLIDECART_OPEN();
    }

    (function tick() {
      if (typeof window.SLIDECART_UPDATE === "function") {
        try {
          window.SLIDECART_UPDATE(doOpen);
        } catch (err) {
          doOpen();
        }
        setTimeout(doOpen, 700);
        return;
      }
      if (typeof window.SLIDECART_OPEN === "function") {
        doOpen();
        return;
      }
      if (++tries > 6) {
        window.location.href = "/cart";
        return;
      }
      setTimeout(tick, 400);
    })();
  }

  function build() {
    var wrap = document.createElement("div");
    wrap.className = "vs-sg";
    wrap.setAttribute("data-vs-sg", "content");

    var h = "";
    h += '<p class="vs-sg__h">Two sizes. Because one shape doesn’t fit every mouth.</p>';
    h += "<p>VitalSleep comes in a Men’s and a Women’s size. Not one mold shrunk down, but two shapes engineered separately.</p>";

    h += '<div class="vs-sg__cards">';
    h += '<div class="vs-sg__card"><p class="vs-sg__card-t">Men’s</p><p class="vs-sg__card-d">The standard fit for most adult men.</p></div>';
    h += '<div class="vs-sg__card"><p class="vs-sg__card-t">Women’s</p><p class="vs-sg__card-d">Shorter and narrower, with a taller profile.</p></div>';
    h += "</div>";

    h += '<table class="vs-sg__table"><thead><tr><th scope="col"><span class="vs-sg__sr">Dimension</span></th><th scope="col">Men’s</th><th scope="col">Women’s</th></tr></thead><tbody>';
    h += '<tr><th scope="row">Length</th><td>2.66&quot; (67.5 mm)</td><td>2.41&quot; (61.1 mm)</td></tr>';
    h += '<tr><th scope="row">Width</th><td>1.97&quot; (50.1 mm)</td><td>1.88&quot; (47.7 mm)</td></tr>';
    h += '<tr><th scope="row">Height</th><td>0.84&quot; (21.4 mm)</td><td>0.94&quot; (23.9 mm)</td></tr>';
    h += "</tbody></table>";

    h += '<p class="vs-sg__foot-note">Why the Women’s size is taller: less horizontal room means the advancement comes from a steeper angle instead of length. Same jaw movement, smaller footprint.</p>';

    h += '<div class="vs-sg__choose">';
    h += '<p class="vs-sg__choose-t">Not sure which one?</p>';
    h += '<p class="vs-sg__quiz-line">Three questions and we’ll tell you. <a class="vs-sg__quiz" href="' + QUIZ_URL + '">Take the 10-second fit quiz</a></p>';
    h += '<div class="vs-sg__btns">';
    h += '<button type="button" class="vs-sg__btn" data-vs-size="men">Add Men’s Size to Cart</button>';
    h += '<button type="button" class="vs-sg__btn" data-vs-size="women">Add Women’s Size to Cart</button>';
    h += "</div>";
    h += '<p class="vs-sg__swap">Free size exchanges. No restocking fee.</p>';
    h += '<p class="vs-sg__err" data-vs-err hidden>That didn’t go through. Please try again, or use the Add to Cart button on the page.</p>';
    h += "</div>";

    wrap.innerHTML = h;
    return wrap;
  }

  function wire(wrap, dlg) {
    var busy = false;
    var err = wrap.querySelector("[data-vs-err]");
    var btns = wrap.querySelectorAll("[data-vs-size]");

    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener("click", function (e) {
        e.preventDefault();
        if (busy) return;

        var btn = this;
        var key = btn.getAttribute("data-vs-size");
        var size = null;
        for (var j = 0; j < SIZES.length; j++) {
          if (SIZES[j].key === key) size = SIZES[j];
        }
        if (!size) return;

        busy = true;
        if (err) err.hidden = true;
        var label = btn.innerHTML;
        btn.innerHTML = "Adding…";
        btn.setAttribute("data-vs-busy", "1");
        for (var k = 0; k < btns.length; k++) btns[k].disabled = true;

        function reset() {
          busy = false;
          btn.innerHTML = label;
          btn.removeAttribute("data-vs-busy");
          for (var m = 0; m < btns.length; m++) btns[m].disabled = false;
        }

        inCart(size)
          .then(function (already) {
            if (already) return null;
            return addToCart(size);
          })
          .then(function () {
            reset();
            closeDialog(dlg, openCart);
          })
          .catch(function () {
            reset();
            if (err) err.hidden = false;
          });
      });
    }
  }

  function styleTrigger() {
    var nodes = document.querySelectorAll('a, button, [role="button"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute("data-vs-sglink")) continue;
      if (el.closest && el.closest(POP_SEL)) continue;
      if (el.closest && el.closest(".vs-sg")) continue;
      var t = txt(el);
      if (!TRIGGER_RE.test(t)) continue;
      if (!visible(el)) continue;

      var node = el;
      var kids = el.querySelectorAll("*");
      for (var k = 0; k < kids.length; k++) {
        if (txt(kids[k]) === t && kids[k].children.length === 0) node = kids[k];
      }
      if (node === el) {
        el.textContent = "";
        var lab = document.createElement("span");
        lab.className = "vs-sglink__t";
        lab.textContent = t;
        el.appendChild(lab);
      } else if (node.classList) {
        node.classList.add("vs-sglink__t");
      }

      var ico = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      ico.setAttribute("class", "vs-sglink__ico");
      ico.setAttribute("viewBox", "0 0 20 20");
      ico.setAttribute("fill", "none");
      ico.setAttribute("aria-hidden", "true");
      ico.innerHTML =
        '<rect x="2.25" y="6.25" width="15.5" height="7.5" rx="1.5" stroke="currentColor" stroke-width="1.5"></rect>' +
        '<path d="M6.25 6.25v3M10 6.25v4.2M13.75 6.25v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>';
      el.insertBefore(ico, el.firstChild);

      el.setAttribute("data-vs-sglink", "1");
      el.classList.add("vs-sglink");
      return true;
    }
    return false;
  }

  function apply() {
    var heading = byText(document, HEAD_RE, "h1,h2,h3,h4,h5,h6,p,div,span,strong,b", 120);
    if (!heading) return false;
    heading = promote(heading);

    var parent = heading.parentElement;
    if (!parent) return false;
    if (parent.getAttribute("data-vs-sg-done") === "1" && parent.querySelector('[data-vs-sg="content"]')) return true;

    var dlg = dialogOf(heading);
    var tail = byText(dlg || parent, TAIL_RE, "p,div,span,em,i,li", 400);

    var kids = Array.prototype.slice.call(parent.childNodes);
    var start = kids.indexOf(heading);
    if (start === -1) return false;

    var end = kids.length - 1;
    if (tail) {
      var t = tail;
      while (t && t.parentElement !== parent) t = t.parentElement;
      if (t) {
        var ti = kids.indexOf(t);
        if (ti >= start) end = ti;
      }
    }

    var doomed = [];
    for (var i = start; i <= end; i++) {
      var n = kids[i];
      if (!n) continue;
      if (isProtected(n)) continue;
      doomed.push(n);
    }
    if (!doomed.length) return false;

    var wrap = build();
    parent.insertBefore(wrap, heading);
    for (var j = 0; j < doomed.length; j++) {
      if (doomed[j].parentNode === parent) parent.removeChild(doomed[j]);
    }
    wire(wrap, dlg);
    parent.setAttribute("data-vs-sg-done", "1");

    if (dlg && !dlg.getAttribute("data-vs-sg-esc")) {
      dlg.setAttribute("data-vs-sg-esc", "1");
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        if (!dlg.querySelector('[data-vs-sg="content"]')) return;
        if (dlg.offsetParent === null) return;
        closeDialog(dlg);
      });
    }
    return true;
  }


  /* 16-Sep-2026 speed fix: the page-wide watcher used to run forever. Any change
     anywhere on the page (the 1-second shipping countdown, carousels, the cart)
     re-ran the text search below. Now it watches for WATCH_MS after load and
     stops as soon as the job is done. A click or a resize re-checks for a few
     seconds, which covers popups and tabs that build their content late. */
  var WATCH_MS = 15000;
  var REARM_MS = 3000;
  function leash(check) {
    var obs = null, stopT = null, queued = false;
    function stop() {
      if (obs) { obs.disconnect(); obs = null; }
      if (stopT) { clearTimeout(stopT); stopT = null; }
    }
    function run() {
      queued = false;
      if (check()) stop();
    }
    function arm(ms) {
      if (!window.MutationObserver) return;
      if (!obs) {
        obs = new MutationObserver(function () {
          if (queued) return;
          queued = true;
          setTimeout(run, 250);
        });
        obs.observe(document.documentElement, { childList: true, subtree: true });
      }
      if (stopT) clearTimeout(stopT);
      stopT = setTimeout(stop, ms);
    }
    var pokeT = null;
    function poke() {
      if (pokeT) return;
      pokeT = setTimeout(function () {
        pokeT = null;
        if (!check()) arm(REARM_MS);
      }, 350);
    }
    if (!check()) arm(WATCH_MS);
    document.addEventListener("click", poke, true);
    window.addEventListener("resize", poke, { passive: true });
  }

  function start() {
    styleTrigger();
    apply();
    leash(function () {
      if (!document.querySelector("[data-vs-sglink]")) styleTrigger();
      if (!document.querySelector('[data-vs-sg="content"]')) apply();
      return !!(document.querySelector("[data-vs-sglink]") && document.querySelector('[data-vs-sg="content"]'));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
